import {
    HomePageCompanyLogo,
    TemplateBackstageLogo,
} from "@backstage/plugin-home";

import styles from "./HomePageLogo.module.css";

export const HomePageLogo = () => {
    return (
        <HomePageCompanyLogo
            className={styles.container}
            logo={
                <TemplateBackstageLogo
                    classes={{ svg: styles.svg, path: styles.path }}
                />
            }
        />
    );
};
